import { environment } from "@env/environment";

export class PayBill {
    public static readonly CA = {
        url: environment.paybill_base_url + 'V2/mapfreinsuranceb2c/Login.aspx',
        source: 'mapfre!00907'
    };

    public static readonly CA_64 = {
        url: environment.paybill_base_url + 'V2/mapfreinsurancewestb2c/Login.aspx',
        source: 'mapfre!00972'
    };

    public static readonly CA_64_104 = {
        url: environment.paybill_base_url + 'v2/cwic104protectionB2C/login.aspx',
        source: 'mapfre!01512'
    }; 

    public static readonly company03 = {
        url: environment.paybill_base_url + 'V2/CommerceV12Agents/Login.aspx',
        source: 'CIV12a_1648'
    };

    public static readonly company05 = {
        url: environment.paybill_base_url + 'V2/CommerceWestv12agent/Login.aspx',
        source: 'From!01165'
    };

    public static readonly company25 = {
        url: environment.paybill_base_url + 'americancommerceinsurance/default.asp',
        source: 'FromACI00572'
    };

    public static readonly nh01 = {
        url: environment.paybill_base_url + 'V2/CommerceInsuranceNH/Login.aspx',
         source: ''
    };

    public static readonly nh03 = {
        url: environment.paybill_base_url + 'v2/cicv12online/login.aspx',
         source: ''
    };
    
    public static readonly as400 = {
        url: environment.paybill_base_url + 'v2/CommerceInsuranceCWEBinstallment/login.aspx',
        source: 'mapfrecweb!01122'
    };

    public static readonly OR = {
        url: environment.paybill_base_url + 'commercewestv12',
         source: ''
    };
    
  }
  